import AccessIssue from '../schema/AccessIssue';
import getAttachmentPolicyBasedOnFlag from './getAttachmentPolicyBasedOnFlag';

/**
 * Those fields combine both conditional access and attachment policy
 * the logic is on the server code
 */

export default function getCombinedAccessIssue(): AccessIssue {
    const attachmentPolicy = getAttachmentPolicyBasedOnFlag();

    if (
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2532 (16,10): Object is possibly 'undefined'.
        // @ts-expect-error
        !attachmentPolicy.DirectFileAccessOnPrivateComputersEnabled ||
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2532 (20,10): Object is possibly 'undefined'.
        // @ts-expect-error
        !attachmentPolicy.DirectFileAccessOnPublicComputersEnabled
    ) {
        if (
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2532 (26,14): Object is possibly 'undefined'.
            // @ts-expect-error
            !attachmentPolicy.WacViewingOnPrivateComputersEnabled ||
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2532 (30,14): Object is possibly 'undefined'.
            // @ts-expect-error
            !attachmentPolicy.WacViewingOnPublicComputersEnabled
        ) {
            return AccessIssue.ReadOnlyPlusAttachmentsBlocked;
        } else {
            return AccessIssue.ReadOnly;
        }
    }
    return AccessIssue.None;
}
